import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-slate-900 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-194" data-mp="30gxtpw8ufdm8">
      <div className="mx-auto max-w-4xl px-4" data-id="element-195" data-mp="30j0qr08ey70g">
        <div className="text-center" data-id="element-196" data-mp="2vpg2w10jatez">
          <h2 id="problem-title" className="text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-197" data-mp="2voehp3pt0qjj">
            Does this sound familiar?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-slate-100" data-id="element-198" data-mp="35fr95u7oxep1">
            Sunday at 11 p.m. Tomorrow you have industrial maintenance class. And you're still searching for the best
            way to explain mechanical systems, electrical troubleshooting, predictive maintenance strategies, and the
            role of industrial maintenance in modern operations without losing your students' attention.
          </p>
          <p className="mx-auto mt-4 max-w-3xl leading-relaxed text-slate-300" data-id="element-199" data-mp="jd3p4sfl0jtj">
            It's not your fault. You've spent years struggling with disorganized materials, dense theory from outdated
            textbooks, and resources designed for contexts you have to completely rewrite.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-xl border border-slate-400/20 bg-slate-800 p-6 shadow-lg shadow-black/20 sm:p-8" data-id="element-200" data-mp="x51r8javlfg7">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-bold text-white" data-id="element-201" data-mp="1c2albkrkcxbm">
            <AlertTriangleIcon className="h-5 w-5 text-red-400" aria-hidden="true" data-id="element-202" data-mp="1g22ykarwjrnb" />
            The real cost of not having the right materials
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-203" data-mp="3huha8s3urzva">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-slate-200" data-id="element-204" data-mp="p092fveijggn">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-red-500" aria-hidden="true" data-id="element-205" data-mp="p23k90uhmsgi" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-206" data-mp="xym47nkqr60y">
          <p className="text-lg font-bold text-white" data-id="element-207" data-mp="tyaie7gn6znw">
            Stop giving away your personal time. Your dedication is already there. What you need now is the right tool.
          </p>
          <p className="metal-text mt-3 text-2xl font-extrabold sm:text-3xl" data-id="element-208" data-mp="130tl8rkfhca5">Plan your entire year today.</p>
        </div>
      </div>
    </section>;
}